module.exports = __webpack_public_path__ + "media/step6_animation_Brueche.ed017d5c.webm";